import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";

import { request } from "../request/request";

const initialState = {
    categories: [],
    loadingStatus: "idle",
    error: null
}

export const fetchFields = createAsyncThunk(
    'fieldsList/fetchFields',
    async ({token}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/reports/create`,
                'GET',
                null,
                customHeaders
            )

            return response;
        } catch (error) {
            rejectWithValue(error.status)
        }
    }
)

const fieldListSlice = createSlice({
    name: 'fieldList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFields.pending, (state) => {
                state.categories = [];
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchFields.fulfilled, (state, action) => {
                state.categories = action.payload?.categories || [];
                state.loadingStatus = "idle";
                state.error = null
            })
            .addCase(fetchFields.rejected, (state, action) => {
                state.categories = [];
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
})

export default fieldListSlice.reducer;